import { inject, Injectable } from '@angular/core';
import { User } from '../entities/user';
import { LocalStorageFacade } from '@application/localstorage';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly localStorageFacade = inject(LocalStorageFacade);

  getUser(email: string): User {
    return this.getUsers().find(u => u.email === email);
  }

  getUsers(): User[] {
    const usersString  = this.localStorageFacade.getItem('users');
    return usersString ? JSON.parse(usersString) : [];
  }

  saveUsers(users: User[]) {
    return this.localStorageFacade.setItem('credentials', JSON.stringify(users));
  }

  addUser(user: User) {
    const users = [...this.getUsers(), user];
    this.saveUsers(users);
  }

  removeUser(email: string) {
    const filteredUsers = this.getUsers().filter(user => user.email !== email);
    this.saveUsers(filteredUsers);
  }
}
